// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"b0115c07","404":"12acea0b"}[chunkId] + ".chunk.js";
};